import React, { useEffect, useRef, useState } from "react";
import { useWebSocket } from "../../../../../../../../context/WebSocketContext";

export default function SubSearch({
  setvCursoFiltro = () => {},
  vCategoriesSelected = [],
  setLastSearchText = () => {},
  setHasSearched = () => {},
}) {
  const { mensajeWs, enviarMensaje, vIsActivo } = useWebSocket();
  const [vTextSearch, setVTextSearch] = useState("");

  const timeoutIdRef = useRef(null);
  const requestIdRef = useRef(0);

  const startTimeout = (id) => {
    clearTimeout(timeoutIdRef.current);
    timeoutIdRef.current = setTimeout(() => {
      if (requestIdRef.current === id) {
        setvCursoFiltro([]); // no llegaron cursos
      }
    }, 1000); 
  };

  const sendSearch = (texto, categorias) => {
    if (!vIsActivo) return;
    const newId = requestIdRef.current + 1;
    requestIdRef.current = newId;
    startTimeout(newId);
    enviarMensaje({
      metadata: { page: 1, requestId: newId },
      data: { texto, categorias },
      accion: "BUSCAR_CURSOS",
    });
  };

  useEffect(() => {
    sendSearch(vTextSearch, vCategoriesSelected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vIsActivo, vCategoriesSelected]);

  const mChangeTextSearch = (val) => {
    setVTextSearch(val);
    setLastSearchText(val);
    setHasSearched(true);
    sendSearch(val, vCategoriesSelected);
  };

  useEffect(() => {
    if (!mensajeWs?.detail) return;
    if (mensajeWs.detail.acción === "MOSTRAR_CURSOS") {
      clearTimeout(timeoutIdRef.current);
      setvCursoFiltro(mensajeWs.detail.datos.cursos);
    }
  }, [mensajeWs, setvCursoFiltro]);

  useEffect(() => () => clearTimeout(timeoutIdRef.current), []);

  return (
    <div className="barra-busqueda" data-figma-id="810:15706">
      <i className="fi fi-rr-search search-3-1" />
      <input
        className="barra-busqueda-texto input-con-placeholder-blanco"
        data-figma-id="810:15708"
        placeholder="Buscar cursos"
        onChange={(e) => mChangeTextSearch(e.target.value)}
      />
    </div>
  );
}
